import { RouteObject, Navigate } from "react-router-dom";
import HomePage from "@/pages/home/page";
import DiscoverPage from "@/pages/discover/page";
import PostDetailPage from "@/pages/post-detail/page";
import AiPlanPage from "@/pages/ai-plan/page";
import OrderFormPage from "@/pages/order-form/page";
import OrderFormTourPage from "@/pages/order-form-tour/page";
import PaymentPage from "@/pages/payment/page";
import OrdersPage from "@/pages/orders/page";
import OrderDetailHotelPage from "@/pages/order-detail/hotel/page";
import OrderDetailMultiPage from "@/pages/order-detail/multi/page";
import OrderDetailTourPage from "@/pages/order-detail/tour/page";
import OrderDetailCarPage from "@/pages/order-detail/car/page";
import OrderDetailExpertPage from "@/pages/order-detail/expert/page";
import ProfilePage from "@/pages/profile/page";
import WalletPage from "@/pages/wallet/page";
import HotelListPage from "@/pages/hotels/page";
import CarListPage from "@/pages/cars/page";
import LocationSelectPage from "@/pages/location-select/page";
import AddressSelectPage from "@/pages/address-select/page";
import RouteListPage from "@/pages/routes/page";
import GuideListPage from "@/pages/guides/page";
import HotelDetailPage from "@/pages/hotel-detail/page";
import CarDetailPage from "@/pages/car-detail/page";
import HotelDetailProductPage from "@/pages/hotel-detail-product/page";
import CarDetailProductPage from "@/pages/car-detail-product/page";
import RouteDetailProductPage from "@/pages/route-detail-product/page";
import GuideDetailProductPage from "@/pages/guide-detail-product/page";
import GuideCommentPage from "@/pages/guide-comment/page";
// ── 达人确认订单（原型还原）──
import ExpertConfirmPage from "@/pages/expert-confirm/page";
import InvitePage from "@/pages/invite/page";
import SettingsPage from "@/pages/settings/page";
import ContractsPage from "@/pages/contracts/page";
import InsurancePage from "@/pages/insurance/page";
import InvoicesPage from "@/pages/invoices/page";
import DepositPaymentPage from "@/pages/deposit-payment/page";
import InquiryOrdersPage from "@/pages/inquiry-orders/page";
import MyPostsPage from "@/pages/my-posts/page";
import MessagesPage from "@/pages/messages/page";
import LandingPage from "@/pages/landing/page";
import SplashPage from "@/pages/splash/page";
import AiVoicePage from "@/pages/ai-voice/page";
import WxAuthPage from "@/pages/wx-auth/page";
import WxCallbackPage from "@/pages/wx-callback/page";
import WorkspacePage from "@/pages/workspace/page";
import WorkspaceHomePage from "@/pages/workspace/home/page";
import WorkspaceOrderPage from "@/pages/workspace/order/page";
import WorkspaceOrderDetailPage from "@/pages/workspace/order/detail";
import WorkspaceOrderReportPage from "@/pages/workspace/order/report";
import WorkspaceOrderCommentPage from "@/pages/workspace/order/comment";
import MoneyCapitalPage from "@/pages/workspace/money/capital";
import MoneyDividePage from "@/pages/workspace/money/divide";
import MoneyRewardPage from "@/pages/workspace/money/reward";
import MoneyWithdrawPage from "@/pages/workspace/money/withdraw";
import WorkspaceProfilePage from "@/pages/workspace/profile/page";
// ── P2 新模块 ──
import WorkspaceCommentPage from "@/pages/workspace/comment/page";
import EditItemPage from "@/pages/workspace/edit-item/page";
import EditItemDetailPage from "@/pages/workspace/edit-item/detail";
import MyCatePage from "@/pages/workspace/edit-item/my-cate";
import ProfileEditPage from "@/pages/workspace/profile/edit";
import EditPlacePage from "@/pages/workspace/edit-place/page";
import EditTimePage from "@/pages/workspace/edit-time/page";
import EmergencyPage from "@/pages/workspace/emergency/page";
import AlbumPage from "@/pages/workspace/album/page";
import WorkspaceRequestionPage from "@/pages/workspace/requestion/page";
import WorkspacePersonnelPage from "@/pages/workspace/personnel/page";
import WorkspacePunchingPage from "@/pages/workspace/punching/page";
import PunchDepartPage from "@/pages/workspace/order/punch-depart";
import RecruitPage from "@/pages/workspace/recruit/page";
import WxAuthGuard from "./WxAuthGuard";
import TalentPrefetch from "./TalentPrefetch";

import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  // 启动页：开场动画（GIF/视频 + 立即开始按钮）→ 点击后进入首页
  { path: "/", element: <SplashPage /> },
  // 首页（原 /home-old）
  // ★ 包 TalentPrefetch：打开首页即预取 is_talent，保证底部「工作台」入口即时准确
  //   注意用轻量守卫而非 WxAuthGuard，避免游客被强制跳转微信授权
  {
    path: "/home",
    element: (
      <TalentPrefetch>
        <HomePage />
      </TalentPrefetch>
    ),
  },
  { path: "/ai-voice", element: <AiVoicePage /> },
  { path: "/wx-auth", element: <WxAuthPage /> },
  { path: "/wx-callback", element: <WxCallbackPage /> },
  { path: "/discover", element: <DiscoverPage /> },
  { path: "/post-detail", element: <PostDetailPage /> },
  // 兼容旧路径
  { path: "/home-old", element: <Navigate to="/home" replace /> },
  { path: "/ai-plan", element: <AiPlanPage /> },
  { path: "/order-form", element: <OrderFormPage /> },
  { path: "/order-form-tour", element: <OrderFormTourPage /> },
  { path: "/payment", element: <PaymentPage /> },
  { path: "/orders", element: <OrdersPage /> },
  { path: "/order", element: <Navigate to="/orders" replace /> },
  {
    path: "/workspace",
    element: (
      <WxAuthGuard>
        <WorkspacePage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/home",
    element: (
      <WxAuthGuard>
        <WorkspaceHomePage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/order",
    element: (
      <WxAuthGuard>
        <WorkspaceOrderPage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/order/detail",
    element: (
      <WxAuthGuard>
        <WorkspaceOrderDetailPage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/order/report",
    element: (
      <WxAuthGuard>
        <WorkspaceOrderReportPage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/order/comment",
    element: (
      <WxAuthGuard>
        <WorkspaceOrderCommentPage />
      </WxAuthGuard>
    ),
  },
  // ── 资金管理 ──
  {
    path: "/workspace/money/capital",
    element: (
      <WxAuthGuard>
        <MoneyCapitalPage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/money/divide",
    element: (
      <WxAuthGuard>
        <MoneyDividePage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/money/reward",
    element: (
      <WxAuthGuard>
        <MoneyRewardPage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/money/withdraw",
    element: (
      <WxAuthGuard>
        <MoneyWithdrawPage />
      </WxAuthGuard>
    ),
  },
  // ── 我的（工作台）──
  {
    path: "/workspace/profile",
    element: (
      <WxAuthGuard>
        <WorkspaceProfilePage />
      </WxAuthGuard>
    ),
  },
  // ── P2 新模块 ──
  {
    path: "/workspace/comment",
    element: (
      <WxAuthGuard>
        <WorkspaceCommentPage />
      </WxAuthGuard>
    ),
  },
  // ── 项目申请 ──
  {
    path: "/workspace/edit-item",
    element: (
      <WxAuthGuard>
        <EditItemPage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/edit-item/detail",
    element: (
      <WxAuthGuard>
        <EditItemDetailPage />
      </WxAuthGuard>
    ),
  },
  {
    path: "/workspace/my-cate",
    element: (
      <WxAuthGuard>
        <MyCatePage />
      </WxAuthGuard>
    ),
  },
  // ── 个人资料编辑 ──
  {
    path: "/workspace/profile/edit",
    element: (
      <WxAuthGuard>
        <ProfileEditPage />
      </WxAuthGuard>
    ),
  },
  // ── 接单位置 ──
  {
    path: "/workspace/edit-place",
    element: (
      <WxAuthGuard>
        <EditPlacePage />
      </WxAuthGuard>
    ),
  },
  // ── 接单时间 ──
  {
    path: "/workspace/edit-time",
    element: (
      <WxAuthGuard>
        <EditTimePage />
      </WxAuthGuard>
    ),
  },
  // ── 紧急联系人 ──
  {
    path: "/workspace/emergency",
    element: (
      <WxAuthGuard>
        <EmergencyPage />
      </WxAuthGuard>
    ),
  },
  // ── 相册管理 ──
  {
    path: "/workspace/album",
    element: (
      <WxAuthGuard>
        <AlbumPage />
      </WxAuthGuard>
    ),
  },
  // ── 问题反馈 ──
  {
    path: "/workspace/requestion",
    element: (
      <WxAuthGuard>
        <WorkspaceRequestionPage />
      </WxAuthGuard>
    ),
  },
  // ── 人员关系 ──
  {
    path: "/workspace/personnel",
    element: (
      <WxAuthGuard>
        <WorkspacePersonnelPage />
      </WxAuthGuard>
    ),
  },
  // ── 打卡记录 ──
  {
    path: "/workspace/punching",
    element: (
      <WxAuthGuard>
        <WorkspacePunchingPage />
      </WxAuthGuard>
    ),
  },
  // ── 出发打卡（地图+拍照）──
  {
    path: "/workspace/order/punch-depart",
    element: (
      <WxAuthGuard>
        <PunchDepartPage />
      </WxAuthGuard>
    ),
  },
  // ── 招募合作伙伴 ──
  {
    path: "/workspace/recruit",
    element: (
      <WxAuthGuard>
        <RecruitPage />
      </WxAuthGuard>
    ),
  },
  { path: "/order/detail", element: <OrderDetailMultiPage /> },
  { path: "/order/detail/multi", element: <OrderDetailMultiPage /> },
  { path: "/order/detail/hotel", element: <OrderDetailHotelPage /> },
  { path: "/order/detail/tour", element: <OrderDetailTourPage /> },
  
  { path: "/order/detail/single", element: <OrderDetailHotelPage /> },
  { path: "/order/detail/car", element: <OrderDetailCarPage /> },
  { path: "/order/detail/guide", element: <OrderDetailHotelPage /> },
  { path: "/order/detail/expert", element: <OrderDetailExpertPage /> },
  {
    path: "/profile",
    element: (
      <WxAuthGuard>
        <ProfilePage />
      </WxAuthGuard>
    ),
  },
  { path: "/wallet", element: <WalletPage /> },
  { path: "/hotels", element: <HotelListPage /> },
  { path: "/cars", element: <CarListPage /> },
  { path: "/location-select", element: <LocationSelectPage /> },
  { path: "/address-select", element: <AddressSelectPage /> },
  { path: "/routes", element: <RouteListPage /> },
  { path: "/guides", element: <GuideListPage /> },
  { path: "/hotel-detail", element: <HotelDetailPage /> },
  { path: "/car-detail", element: <CarDetailPage /> },
  { path: "/hotel-detail-product", element: <HotelDetailProductPage /> },
  { path: "/car-detail-product", element: <CarDetailProductPage /> },
  { path: "/route-detail-product", element: <RouteDetailProductPage /> },
  { path: "/guide-detail-product", element: <GuideDetailProductPage /> },
  { path: "/expert-confirm", element: <ExpertConfirmPage /> },
  { path: "/guide-comment", element: <GuideCommentPage /> },
  { path: "/expert-confirm", element: <ExpertConfirmPage /> },
  { path: "/invite", element: <InvitePage /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/contracts", element: <ContractsPage /> },
  { path: "/insurance", element: <InsurancePage /> },
  { path: "/invoices", element: <InvoicesPage /> },
  { path: "/deposit-payment", element: <DepositPaymentPage /> },
  { path: "/inquiry-orders", element: <InquiryOrdersPage /> },
  { path: "/my-posts", element: <MyPostsPage /> },
  { path: "/messages", element: <MessagesPage /> },
  { path: "/landing", element: <LandingPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
